import { useCallback, useEffect, useState } from "react";
import Button from "../../../../../button/button"
import BackArrow from '../../../../../icons/backArrow';
import PaymentMethodSubForm from "./PaymentMethodSubForm";
import './SplitPay.scss'
const SplitPay = (props) => {
    const [remaining, setRemaining] = useState();
    const [remainingUSD, setRemainingUSD] = useState();
    const [methods, setMethods] = useState([
        { id: Date.now(), method: '', amount: '', currency: '' },
        { id: Date.now() + 1, method: '', amount: '', currency: '' }
    ]);


    // Function to add a new student section to the receipt
    const addMethod = () => {
        setMethods(prev => [
            ...prev,
            { id: Date.now(), method: '', amount: '', currency: '' }
        ]);
    };

    // Función para eliminar un método de pago
    //Remover metodo de pago
    const removeMethodSubform = (id) => {
        setMethods(prev => prev.filter(method => method.id !== id));
    };

    // Callback para actualizar el amount de un método específico
    const updateMethodAmount = useCallback((index, newAmount, newCurrency, methodName) => {
        setMethods(prevMethods => {
            const updatedMethods = [...prevMethods];

            updatedMethods[index] = {
                ...updatedMethods[index],
                method: methodName,
                currency: newCurrency,
                rawAmount: parseFloat(newAmount || 0)
            };

            // Paso 1: Calcular total recibido
            let totalReceived = 0;
            updatedMethods.forEach((m) => {
                const raw = parseFloat(m.rawAmount || 0);
                const amountInMXN = m.currency === "USD" ? raw * props.exchange : raw;
                totalReceived += amountInMXN;
            });

            // Paso 2: Calcular exceso sobre el total a pagar
            let change = totalReceived - props.totalAmount;

            // Paso 3: Ajustar los amount reales usados
            const adjustedMethods = updatedMethods.map((m, i) => {
                const raw = parseFloat(m.rawAmount || 0);
                const isEfectivoMXN = m.method === "EfectivoMXN" && m.currency === "MXN";

                let realAmount = raw;

                if (isEfectivoMXN && change > 0) {
                    const used = raw - change;
                    realAmount = used >= 0 ? used : 0;
                    change = Math.max(change - raw, 0); // actualizar el cambio restante
                }

                return {
                    ...m,
                    amount: realAmount.toFixed(2)
                };
            });

            return adjustedMethods;
        });
    }, [props.totalAmount, props.exchange]);

    const calculateTotal = useCallback(() => {
        const total = methods.reduce((total, method) => {
            const amountInMXN = method.currency === "USD" ? method.rawAmount * props.exchange : method.rawAmount;
            return total + parseFloat(amountInMXN || 0); // Sumar los montos sin formatear
        }, 0);

        return total.toFixed(2); // Formatear el total final a 2 decimales
    }, [methods, props.exchange]);

    const calculateRemaining = useCallback(() => {
        const totalReceived = parseFloat(calculateTotal());
        const newRemaining = props.totalAmount - totalReceived;

        // Verifica si se pagó de más
        const overpaid = newRemaining < 0;

        // Verifica si hay efectivo MXN para dar cambio
        const hasCashMXN = methods.some(
            (m) => m.method === "EfectivoMXN" && m.currency === "MXN"
        );
        // 🚫 Condición de error: pago de más sin forma de dar cambio
        if (overpaid && !hasCashMXN) {
            // Aquí podrías bloquear el botón de continuar o mostrar un error
            console.warn("No se puede dar cambio sin Efectivo MXN");
            props.stateRemaining(true); // Podrías usar un nuevo estado si quieres distinguir
        } else {
            props.stateRemaining(newRemaining > 0);
        }

        setRemaining(newRemaining.toFixed(2));
        setRemainingUSD((newRemaining / props.exchange).toFixed(2));
    }, [calculateTotal, props.totalAmount, props.exchange, methods]);

    // Efecto para actualizar el restante cuando cambian los métodos de pago
    useEffect(() => {
        calculateRemaining();
        props.setPaymentMethod(methods)
    }, [methods, calculateRemaining]);

    return (
        <div className="split-pay">
            <div className="methods">
                {methods.map((method, index) =>
                    <PaymentMethodSubForm
                        key={method.id} // Si `method` tiene un `id`, úsalo; de lo contrario, usa el índice
                        method={method}
                        index={index}
                        updateMethodAmount={updateMethodAmount}
                        removeMethodSubform={removeMethodSubform}
                        exchange={props.exchange}
                    />
                )}
                <Button text={'+Agregar metodo de pago'} backgroundColor="add-style" onClick={addMethod} />

            </div>

            <div className="total-remaining">
                <h2 className="title-3">Total recibido: {calculateTotal()}</h2>
                <h2 className="title-2">Restante: {remaining} MXN / {remainingUSD} USD</h2>
            </div>
        </div>
    )
}
export default SplitPay